import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { first } from 'rxjs/operators'
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatChipInputEvent} from '@angular/material/chips';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from "@ngx-translate/core";
import { lang_cerv3 } from 'app/idiomas/i18n/cerV3/cerv3.lang';
import Swal from 'sweetalert2';
import {MatSnackBar} from '@angular/material/snack-bar';
import { PreguntasService } from "../../../preguntas.service";
import { SurveyProductService } from "app/main/wizard-cgo/survey-product/survey-product.service";

import { ModalComponent } from "../modal/modal.component";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.scss']
})
export class DetalleComponent implements OnInit {


  edicionPregunta = false;
  listasPreguntas: any[] = ['lista0'];

  //tipos de pregunta de acuerdo al catalogo de answerType
  tiposPreguntas = [
    { nombre: 'De una opción', tipo: 1, seccion: [1,3] }, //una opcion para nps
    { nombre: 'Abierta', tipo: 2, seccion: [1,3] }, //abierta para nps
    { nombre: 'Abierta', tipo: 2, seccion: [4,5,7] },
    { nombre: 'Reactivo', tipo: 3, seccion: [2] },
    { nombre: 'De una opción', tipo: 4, seccion: [4,7] },
    { nombre: 'De opción múltiple', tipo: 6, seccion: [4,7] },
  ];
  tiposAbiertas = [
    { nombre: 'Texto abierto', tipo: 1 },
    { nombre: 'Texto numérico', tipo: 2 }
  ];

  tipoEspecial = [
    { nombre: 'Pregunta normal', tipo: 1 },
    { nombre: 'Pregunta especial', tipo: 2 }
  ];

  datosPreguntaNueva: any = {
    pregunta: '',
    descripcion: '',
    tipo: 0,
    tipoAbierta: 0,
    respuestas: [],
    respuestasTextos: [],
    tags: [],
    demografico: 0,
    typeCustom:1,
    key:'',
  };

  datosPracticaNueva: any = {
    practica: '',
    descripcion: ''
  };

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  preguntaRecuperada: boolean;
  vocesHabilitadas: boolean;
  infoVoces: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<DetalleComponent>,
    private _snackBar: MatSnackBar,
    private preguntasService: PreguntasService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private dialog: MatDialog,
    public sanitizer: DomSanitizer,
    private surveyProductService: SurveyProductService
  ) {
    lang_cerv3.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    }); }

  async ngOnInit() {
    console.log("datosRecibidos:",this.datos);
    if(this.datos.configTemplate != undefined){
      if(this.datos.configTemplate.audios == true && this.datos.configTemplate.audiosGlobal == true){
        this.recuperaConfigVoces(); //solo si las banderas de audios estan activas, se recupera la configuracion de voces
        this.vocesHabilitadas = true;
      }
    }
    /// HACER EL GETONE DEL CATALOGO MAESTRO
    // this.datos.pregCat = RESPUESTA DEL GETONE
    if (this.datos.pregCat) {
      let {question: datosPreguntaCat} = await this.preguntasService.getPreguntaCatMaster(this.datos.pregCat.idUnique).toPromise();
      this.datos.pregCat = datosPreguntaCat;
      this.preguntaRecuperada = true;
    }

    if(this.datos.tipoSeccion){
      switch (this.datos.tipoSeccion) {
        case 1:  // si entra como seccion nps
          console.log("entro caso 1, datosPreguntaNueva:",this.datosPreguntaNueva);
        break;
        case 2:  // si entra como seccion reactivos se pone la pregunta tipo 3
          this.datosPreguntaNueva.tipo = 3;
          console.log("entro caso 2, datosPreguntaNueva:REACTIVOS",this.datosPreguntaNueva);
        break;
        case 3:  // si entra como seccion control
          console.log("entro caso 3, datosPreguntaNueva:",this.datosPreguntaNueva);
        break;
        case 4:  // si entra como seccion demograficos
          console.log("entro caso 4, datosPreguntaNueva:",this.datosPreguntaNueva);
        break;
        case 5:  //si entra como seccion abiertas se pone la pregunta tipo 2
          this.datosPreguntaNueva.tipo = 2;
          console.log("entro caso 5, datosPreguntaNueva:",this.datosPreguntaNueva);
        break;
        default:
          console.log("entro caso diferente, datosPreguntaNueva:",this.datosPreguntaNueva);
        break;
      }
    }
  }

  editaPregunta(versionActual:number){
    let titulo = "CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_EDIT_PREG_MOD_PREG";
    let btnCancelar = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CAN_MOD_GUA_CAM_TEMP';
    let btnAgregar = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_AGRE_MOD_GUA_CAM_TEMP';
    this.translateSrv.get(titulo).subscribe((res: string) => { titulo = res; });
    this.translateSrv.get(btnCancelar).subscribe((res: string) => { btnCancelar = res; });
    this.translateSrv.get(btnAgregar).subscribe((res: string) => { btnAgregar = res; });
    let valor = this.datos.pregunta.versiones[versionActual].pregunta;

    Swal.fire({
      title: titulo,
      input: 'textarea',
      inputValue: valor,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: btnAgregar,
      cancelButtonText: btnCancelar,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        let tituloMod = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_2_OPCIO';
        let btnConAc = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CONF_ACT';
        let btnCanNe = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CANC_NEW';
        this.translateSrv.get(tituloMod).subscribe((res: string) => { tituloMod = res; });
        this.translateSrv.get(btnConAc).subscribe((res: string) => { btnConAc = res; });
        this.translateSrv.get(btnCanNe).subscribe((res: string) => { btnCanNe = res; });

        Swal.fire({
          title: tituloMod,
          showCancelButton: true,
reverseButtons: true,
          confirmButtonText: btnConAc,
          cancelButtonText: btnCanNe,
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading()
        }).then((resultadoItbm) => {
          let datosPregunta = this.datos.pregunta;
          let confirMsg: string;
          if (resultadoItbm.value) {  //actualizar version
            datosPregunta.versiones[versionActual].pregunta = result.value;
            confirMsg = "CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1";
            this.translateSrv.get(confirMsg).subscribe((res: string) => { confirMsg = res; });

            datosPregunta.enCM = true;
            this.datos.pregunta = datosPregunta;
            Swal.close();
            this.openSnackBar(confirMsg, "OK");
          }
          else{   //guardar nueva version
            datosPregunta.versiones.push({ pregunta: result.value });
            datosPregunta.versionActual = datosPregunta.versiones.length - 1;
            confirMsg = "CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1";
            this.translateSrv.get(confirMsg).subscribe((res: string) => { confirMsg = res; });

            datosPregunta.enCM = true;
            this.datos.pregunta = datosPregunta;
            Swal.close();
            this.openSnackBar(confirMsg, "OK");
          }
        });
      }

    });
  }

  agregaRespuesta(nuevaPregunta?:boolean){
    let titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_NUE_OPC_RESP');
    let texto = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_NUE_OPC_RESP');
    let btnCancelar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CAN_MOD_GUA_CAM_TEMP');
    let btnAgregar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_AGRE_MOD_GUA_CAM_TEMP');
    let returns = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_NO_TEXT_PREG');

    Swal.fire({
      title: titulo,
      text: texto,
      input: 'textarea',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: btnAgregar,
      cancelButtonText: btnCancelar,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      inputValidator: nombrePregunta => {
        // Si el valor es válido, debes regresar undefined. Si no, una cadena
        if (!nombrePregunta) {
            return returns;
        } else {
            return undefined;
        }
      }
    }).then((result) => {
      if (result.value) {
        if(!nuevaPregunta){   //si se agrega a una pregunta ya existente
          let idiomasAnswer: any[] = [];
          let indiceIdiomaNativo = this.datos.idiomas.findIndex(item => item.tipoIdioma == 1);
          this.datos.catalogoIdiomasSurvey.forEach(idioma => {
            let textoPreguntaNuevo = "";
            if(idioma.abbr == this.datos.idiomas[indiceIdiomaNativo].nombreIdioma){
              textoPreguntaNuevo = result.value;
            }
            idiomasAnswer.push({
              idLanguage: idioma.idLanguage,
              lang: idioma.abbr,
              tag: textoPreguntaNuevo,
              vivo: 1
            });
          });
          let refPregCat = this.datos.pregCat;
          let datosNuevaRespuesta: any = {
            answerLanguage: idiomasAnswer,
            delete: true,
            edit: true,
            // idUnique: this.datos.pregunta.answers.length + 1,
            idUnique: refPregCat != undefined ? refPregCat.answers.length + 1 : this.datos.pregunta.answers.length + 1,  //debe ser el de la pregunta de catalogo, porque aunque haya respuestas "borradas", el idUnique consecutivo sigue
            logics: [],
            typeAdd: 0,
            value: (this.datos.pregunta.answers.length + 1).toString(),
            versionId: 1,
            vivo: 1,
          };
          if(this.datos.modoUsuario){    //si se agrega como usuario empresa su typeadd es 5
            if(this.datos.pregunta.typeAdd != 2){
              datosNuevaRespuesta.typeAdd = 2;
            }
          }
          //agrega a la pregunta la opcion de respuesta
          this.datos.pregunta.answers.push(datosNuevaRespuesta);
          if(this.datos.modoUsuario){    //modificar como empresa
            if(this.datos.pregunta.typeAdd != 2){   //si la pregunta ya está en catalogo, se cambia el status typeAdd a 5  5 = modificacion en opcion respuesta
              this.datos.pregunta.typeAdd = 2;
            }
          }
          if(!this.datos.modoUsuario){    //modificar como itbm
            if(this.datos.pregunta.typeAdd != 2){   //si la pregunta ya está en catalogo, se le guarda la opcion de respuesta
              //modifica las respuestas a la pregunta catalogo
              let datosPreguntaCat = this.datos.pregCat;
              let idiomasNuevaOpcion: any[] = [];
              let indiceIdiomaNativo = this.datos.idiomas.findIndex(item => item.tipoIdioma == 1);
              this.datos.catalogoIdiomasSurvey.forEach(idioma => {
                let textoPreguntaNuevo = "";
                if(idioma.abbr == this.datos.idiomas[indiceIdiomaNativo].nombreIdioma){
                  textoPreguntaNuevo = result.value;
                }
                idiomasNuevaOpcion.push({
                  idLanguage: idioma.idLanguage,
                  lang: idioma.abbr,
                  tag: textoPreguntaNuevo,
                  vivo: 1
                });
              });
              let datosNuevaOpcion = {
                idUnique: datosPreguntaCat.answers.length + 1,
                textVersions: [{
                  answerLanguage: idiomasNuevaOpcion,
                  versionId: 1,
                  vivo: 1
                }],
                value: (datosPreguntaCat.answers.length + 1).toString(),
                vivo: 1,
              };
              datosPreguntaCat.answers.push(datosNuevaOpcion);
              console.log("datosPreguntaCatMod:",datosPreguntaCat);
              this.actualizaPreguntaCatMaster(datosPreguntaCat);
            }
          }
        }
        else{   //si se agrega a una pregunta nueva (sin guardarse a json cuestionario todavia)
          this.datosPreguntaNueva.respuestas.push({
            versiones: [
              { respuesta: result.value }
            ],
            versionActual: 0,
            banderas: {
              editable: true,
              eliminable: true
            }
          });
        }
        Swal.close();
        this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_AGRE_OPC_RESP'), "OK");
      }
    });
  }

  editaRespuesta(versionActual:number, indiceRespuesta:number, modo:number, nuevaPregunta?:boolean){
    console.log("entro este roollloo");

    let valorRespuesta: any;
    let indiceIdioma: any;
    let datosRespuesta: any;
    let titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_EDIT_RESP');
    let btnCancelar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CAN_MOD_GUA_CAM_TEMP');
    let btnContinuar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CONTI_MOD_GUA_CAM_TEMP');
    if(nuevaPregunta){
      console.log("entro primer if ");
      valorRespuesta = this.datosPreguntaNueva.respuestas[indiceRespuesta].versiones[versionActual].respuesta;
    }
    else{
      console.log("entro elelsedel if ");
      datosRespuesta = this.datos.pregunta.answers[indiceRespuesta];
      indiceIdioma = datosRespuesta.answerLanguage.findIndex(item => item.lang == this.datos.idiomaNative);
      valorRespuesta = datosRespuesta.answerLanguage[indiceIdioma].tag;
    }
    Swal.fire({
      title: titulo,
      input: 'textarea',
      inputValue: valorRespuesta,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: btnContinuar,
      cancelButtonText: btnCancelar,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if(result.value) {
        console.log("preciono editar");

        if(nuevaPregunta){
          console.log("entro nueva pregunta");
          this.datosPreguntaNueva.respuestas[indiceRespuesta].versiones[versionActual].respuesta = result.value;
        }
        else{
          if(modo == 1){    //modificar como empresa
            if (result.value) {
              datosRespuesta.answerLanguage[indiceIdioma].tag = result.value;
              datosRespuesta.typeAdd = 5;
              this.datos.pregunta.answers[indiceRespuesta] = datosRespuesta;
              if(this.datos.pregunta.typeAdd != 2){    //si es una pregunta aun no guardad en catalogo
                this.datos.pregunta.typeAdd = 5;  //tipo 4 = modificacion en pregunta, tipo 5 = modificacion en opcion respuesta
              }
              Swal.close();
              this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_EDIT_MODIF_OPC_RESP'), "OK");
            }
          }
          else if(modo == 2){   //modo itbm
            console.log("entro modo itbm");

            if (result.value) {
              if(this.datos.pregunta.typeAdd == 2){    //si es una pregunta aun no guardad en catalogo
                datosRespuesta.answerLanguage[indiceIdioma].tag = result.value;
                datosRespuesta.typeAdd = 5;
                this.datos.pregunta.answers[indiceRespuesta] = datosRespuesta;
              }
              else{   //si es una pregunta ya guardada en catalogo
                let tituloMod = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_2_OPCIO');
                let btnConAc = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CONF_ACT');
                let btnCanNe = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CANC_NEW');
                Swal.fire({
                  title: tituloMod,
                  showCancelButton: true,
reverseButtons: true,
                  confirmButtonText: btnConAc,
                  cancelButtonText: btnCanNe,
                  showLoaderOnConfirm: true,
                  allowOutsideClick: () => !Swal.isLoading()
                }).then((resultadoItbm) => {
                  let datosPreguntaCat = this.datos.pregCat;
                  let indiceRespPregCat = datosPreguntaCat.answers.findIndex(item => item.idUnique == datosRespuesta.idUnique);

                  if (resultadoItbm.value) {  //actualizar version
                    //cambia el texto a la opcion
                    datosRespuesta.answerLanguage[indiceIdioma].tag = result.value;
                    //actualiza el texto a la opcion del catalogo
                    let indiceVersionPregCat = datosPreguntaCat.answers[indiceRespPregCat].textVersions.findIndex(item => item.versionId == datosRespuesta.versionId);
                    let indiceLangVersPregCat = datosPreguntaCat.answers[indiceRespPregCat].textVersions[indiceVersionPregCat].answerLanguage.findIndex(item => item.lang == this.datos.idiomaNative);
                    datosPreguntaCat.answers[indiceRespPregCat].textVersions[indiceVersionPregCat].answerLanguage[indiceLangVersPregCat].tag = result.value;
                    console.log("datosRespuesta:",datosRespuesta);
                    console.log("datosPreguntaCatMod:",datosPreguntaCat);
                    this.actualizaPreguntaCatMaster(datosPreguntaCat);
                    Swal.close();
                    this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_EDIT_MODIF_OPC_RESP'), "OK");
                  }
                  else{ //agregar nueva version
                    let idiomasNuevaVersion: any[] = [];
                    let indiceIdiomaNativo = this.datos.idiomas.findIndex(item => item.tipoIdioma == 1);
                    this.datos.catalogoIdiomasSurvey.forEach(idioma => {
                      let textoPreguntaNuevo = "";
                      if(idioma.abbr == this.datos.idiomas[indiceIdiomaNativo].nombreIdioma){
                        textoPreguntaNuevo = result.value;
                      }
                      idiomasNuevaVersion.push({
                        idLanguage: idioma.idLanguage,
                        lang: idioma.abbr,
                        tag: textoPreguntaNuevo,
                        vivo: 1
                      });
                    });
                    let datosNuevaVersion = {
                      answerLanguage: idiomasNuevaVersion,
                      versionId: (datosPreguntaCat.answers[indiceRespPregCat].textVersions.length + 1),
                      vivo: 1,
                    };
                    datosPreguntaCat.answers[indiceRespPregCat].textVersions.push(datosNuevaVersion);
                    console.log("datosPreguntaCatMod:",datosPreguntaCat);
                    this.actualizaPreguntaCatMaster(datosPreguntaCat);
                    Swal.close();
                    this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_EDIT_MODIF_OPC_RESP'), "OK");
                  }
                });
              }
            }
          }
        }
      }
    });
  }

  borraRespuesta(indiceRespuesta:number, nuevaPregunta?:boolean){
    let titulo = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_COMFIR_DELE_OPC_RESP';
    let btnSi = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_SI'
    let btnNo = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_NO'
    this.translateSrv.get(titulo).subscribe((res: string) => { titulo = res; });
    this.translateSrv.get(btnSi).subscribe((res: string) => { btnSi = res; });
    this.translateSrv.get(btnNo).subscribe((res: string) => { btnNo = res; });

    Swal.fire({
      title: titulo,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: btnSi,
      cancelButtonText: btnNo,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        if(nuevaPregunta){
          this.datosPreguntaNueva.respuestas.splice(indiceRespuesta,1);
        }
        else{
          if(this.datos.modoUsuario){    //modificar como empresa
            this.datos.pregunta.answers.splice(indiceRespuesta,1);
            //REESCRIBE EL VALUE ORDENADO A TODAS LAS RESPUESTAS
            this.datos.pregunta.answers.forEach((respuesta, i) => {
              respuesta.value = (i + 1).toString();
            });
            if(this.datos.pregunta.typeAdd != 2){    //si es una pregunta aun no guardad en catalogo
              this.datos.pregunta.typeAdd = 5;  //tipo 4 = modificacion en pregunta, tipo 5 = modificacion en opcion respuesta
            }
            Swal.close();
            this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SUCC_DELE_OPC_RESP'), "OK");
          }
          if(!this.datos.modoUsuario){    //modificar como itbm
            //borra a la pregunta la opcion de respuesta
            if(this.datos.pregunta.typeAdd != 2){    //si es una pregunta aun no guardad en catalogo
              this.datos.pregunta.answers.splice(indiceRespuesta,1);
              //REESCRIBE EL VALUE ORDENADO A TODAS LAS RESPUESTAS
              this.datos.pregunta.answers.forEach((respuesta, i) => {
                respuesta.value = (i + 1).toString();
              });
              let datosPreguntaCat = this.datos.pregCat;
              if(this.datos.pregunta.answers[indiceRespuesta].typeAdd != 2){  //si la respuesta no es nueva (aún no agregada a la  pregunta del catalogo)
                let idUniqueRespPregunta = this.datos.pregunta.answers[indiceRespuesta].idUnique;
                let indiceRespPregCat = datosPreguntaCat.answers.findIndex(item => item.idUnique == idUniqueRespPregunta);
                // datosPreguntaCat.answers.splice(indiceRespPregCat,1);
                datosPreguntaCat.answers[indiceRespPregCat].vivo = 0;
                console.log("datosPreguntaCatMod:",datosPreguntaCat);
                this.actualizaPreguntaCatMaster(datosPreguntaCat, this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_RESP_DELOK'));
                Swal.close();
              }
              else{
                Swal.close();
                this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_RESP_DELOK'), "OK");
              }
            }
            else{
              this.datos.pregunta.answers.splice(indiceRespuesta,1);
              //REESCRIBE EL VALUE ORDENADO A TODAS LAS RESPUESTAS
              this.datos.pregunta.answers.forEach((respuesta, i) => {
                respuesta.value = (i + 1).toString();
              });
              Swal.close();
              this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SUCC_DELE_OPC_RESP'), "OK");
            }
          }
        }
      }
    });
  }

  guardaNuevaVersionRespuesta(datosPregunta: any){
    let respuestasModificadas = false;
    let datosPreguntaCat = this.datos.pregCat;
    let indiceIdiomaNativo = this.datos.idiomas.findIndex(item => item.tipoIdioma == 1);
    datosPregunta.answers.forEach((respuesta,i) => {
      if(respuesta.typeAdd == 5){ //si encuentra una respuesta con typeadd 5, le guarda el texto como nueva version
        let idiomasNuevaVersion: any[] = [];
        let datosRespuesta = this.datos.pregunta.answers[i];
        let indiceRespPregCat = datosPreguntaCat.answers.findIndex(item => item.idUnique == datosRespuesta.idUnique);
        let indiceLangNatResp = datosRespuesta.answerLanguage.findIndex(item => item.lang == this.datos.idiomas[indiceIdiomaNativo].nombreIdioma);
        this.datos.catalogoIdiomasSurvey.forEach(idioma => {
          let textoPreguntaNuevo = "";
          if(idioma.abbr == this.datos.idiomas[indiceIdiomaNativo].nombreIdioma){
            textoPreguntaNuevo = datosRespuesta.answerLanguage[indiceLangNatResp].tag;
          }
          idiomasNuevaVersion.push({
            idLanguage: idioma.idLanguage,
            lang: idioma.abbr,
            tag: textoPreguntaNuevo,
            vivo: 1
          });
        });
        let datosNuevaVersion = {
          answerLanguage: idiomasNuevaVersion,
          versionId: (datosPreguntaCat.answers[indiceRespPregCat].textVersions.length + 1),
          vivo: 1,
        };
        datosPreguntaCat.answers[indiceRespPregCat].textVersions.push(datosNuevaVersion);
        //actualiza datos en el json cuestionario
        datosPregunta.answers[i].answerLanguage = datosNuevaVersion.answerLanguage;
        datosPregunta.answers[i].versionId = datosNuevaVersion.versionId;
        datosPregunta.answers[i].typeAdd = 0;
        datosPregunta.typeAdd = 1;
        respuestasModificadas = true;
      }
    });
    if(respuestasModificadas){
      console.log("datosPreguntaCatMod:",datosPreguntaCat);
      this.actualizaPreguntaCatMaster(datosPreguntaCat);
      Swal.close();
      this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_EDIT_MODIF_OPC_RESP'), "OK");
    }
  }

  guardaNuevaRespuesta(datosPregunta: any){
    let datosPreguntaCat = this.datos.pregCat;
    let respuestasAgregadas = false;
    datosPregunta.answers.forEach((respuesta,i) => {
      if(respuesta.typeAdd == 2){ //si encuentra una respuesta con typeadd 2, la guarda a la pregunta
        //modifica las respuestas a la pregunta catalogo
        let datosNuevaOpcion = {
          idUnique: datosPreguntaCat.answers.length + 1,
          textVersions: [{
            answerLanguage: respuesta.answerLanguage,
            versionId: 1,
            vivo: 1
          }],
          value: (datosPreguntaCat.answers.length + 1).toString(),
          vivo: 1,
        };
        datosPreguntaCat.answers.push(datosNuevaOpcion);
        respuesta.typeAdd = 0;
        respuestasAgregadas = true;
      }
    });
    if(respuestasAgregadas){
      console.log("datosPreguntaCatMod:",datosPreguntaCat);
      this.actualizaPreguntaCatMaster(datosPreguntaCat);
    }
  }

  //////////////////////////////////////////////////

  cambiaBanderaPregunta(event:any, datosPregunta:any, banderaRequired?:boolean){
    console.log("statusBandera:",event.checked);
    if(banderaRequired){
      switch (event.checked) {
        case true:
          datosPregunta.required = 1;
        break;
        case false:
          datosPregunta.required = 0;
        break;
      }
    }
    if(datosPregunta.idUnique < 99999){  //solo se considera preguntas agregadas de catalogo (idUnique < 99999), si el idUnique es mayor, por default la pregunta ya es considerada nueva en el template
      datosPregunta.typeAdd = 1;
    }
  }
  cambiaBanderaRespuesta(datosRespuesta:any, tipoBandera:number){
    switch (tipoBandera) {
      case 1: //edit
        datosRespuesta.edit = !datosRespuesta.edit;
      break;
      case 2: //delete
        datosRespuesta.delete = !datosRespuesta.delete;
      break;
    }
  }
  revisaRespuestaOtro(respuestas:any){
    const conOtro = (respuesta) => respuesta.answerType == 2;
    return respuestas.some(conOtro);
  }
  cambiaTipoRespuesta(datosRespuesta:any, indice:number, tipo:number){
    datosRespuesta.answerType = datosRespuesta.answerType == 1 || datosRespuesta.answerType == undefined ? 2 : 1;
  }

  cambiaVersionPreguntaTemplate(datosPregunta:any, indiceSeccion:number, indicePregunta:number, indiceVersionPregCat:number){
    const refPregCat:any = this.datos.pregCat.textVersions[indiceVersionPregCat];
    const versionDiferente = refPregCat.versionId != datosPregunta.versionId ? true : false;
    // console.log("datosPregunta:",JSON.parse(JSON.stringify(datosPregunta)));
    // console.log("datosPreguntaCat:",JSON.parse(JSON.stringify(refPregCat)));
    datosPregunta.versionId = refPregCat.versionId;
    datosPregunta.questionLanguage = refPregCat.questionLanguage;
    if(this.vocesHabilitadas == true && versionDiferente == true){
      this.getQuestionAudio(this.datos.pregCat.idUnique, refPregCat.versionId, datosPregunta);
    }
  }
  cambiaVersionRespuestaTemplate(datosRespuesta:any, indiceRespuesta:number, indiceVersionPregCat:number){
    // console.log("datosRespuesta:",datosRespuesta);
    datosRespuesta.versionId = this.datos.pregCat.answers[indiceRespuesta].textVersions[indiceVersionPregCat].versionId;
    datosRespuesta.answerLanguage = this.datos.pregCat.answers[indiceRespuesta].textVersions[indiceVersionPregCat].answerLanguage;
  }

  editaPreguntaTemplate(datosPregunta:any, indiceSeccion:any, indicePregunta:any){
    let titulo = "CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_EDIT_PREG_MOD_PREG";
    let btnCancelar = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CAN_MOD_GUA_CAM_TEMP';
    let btnContinuar = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CONTI_MOD_GUA_CAM_TEMP';
    this.translateSrv.get(titulo).subscribe((res: string) => { titulo = res; });
    this.translateSrv.get(btnCancelar).subscribe((res: string) => { btnCancelar = res; });
    this.translateSrv.get(btnContinuar).subscribe((res: string) => { btnContinuar = res; });


    let valor: any;
    let indiceIdioma = datosPregunta.questionLanguage.findIndex(item => item.lang == this.datos.idiomaNative);
    valor = datosPregunta.questionLanguage[indiceIdioma].question;

    Swal.fire({
      title: titulo,
      input: 'textarea',
      inputValue: valor,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: btnContinuar,
      cancelButtonText: btnCancelar,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      let datosPregunta = this.datos.pregunta;
      if(this.datos.modoUsuario){    //modificar como empresa
        if (result.value) {
          datosPregunta.questionLanguage[indiceIdioma].question = result.value;
          datosPregunta.typeAdd = 2;
          Swal.close();
          this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1'), "OK");
        }
      }
      else if(!this.datos.modoUsuario){   //modo itbm
        if (result.value) {

          ///PREGUNTAR PRIMERO EN DONDE GUARDAR, ESTA ENCUESTA O ACTUALIZAR PREGUTNA CATALOGO
          if (parseInt(localStorage.getItem('instituto_id'))!=2) {
            Swal.fire({
              title: this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SAVE_CAMB_PREGCAT"),
              showCancelButton: true,
              reverseButtons: true,
              confirmButtonText: this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_MOD_SAVE_CAMB_PREGCAT"),
              cancelButtonText: this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_MOD_ACTUA_PREGCAT"),
              showLoaderOnConfirm: true,
              allowOutsideClick: () => !Swal.isLoading()
            }).then((resultadoPregunta_1) => {
              console.log(resultadoPregunta_1);

              if (resultadoPregunta_1.isConfirmed) {  // a esta encuesta
                datosPregunta.questionLanguage[indiceIdioma].question = result.value;
                datosPregunta.typeAdd = 4;
                Swal.close();
                this.openSnackBar(this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1"), "OK");
              } else if (resultadoPregunta_1.isDenied) {  // actualizar catalogo
                Swal.fire({
                  title: this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_2_OPCIO'),
                  showCancelButton: true,
                  reverseButtons: true,
                  confirmButtonText: this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CONF_ACT_VERSION'),
                  cancelButtonText: this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CANC_NEW_VERSION'),
                  showLoaderOnConfirm: true,
                  allowOutsideClick: () => !Swal.isLoading()
                }).then((resultadoItbm) => {
                  let confirMsg: string;
                  if (resultadoItbm.value) {  //actualizar version
                    //actualiza texto de la pregunta en el template
                    datosPregunta.questionLanguage[indiceIdioma].question = result.value;
                    confirMsg = "CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1";
                    this.translateSrv.get(confirMsg).subscribe((res: string) => { confirMsg = res; });

                    datosPregunta.typeAdd = 1;
                    //actualiza texto de la pregunta en el catalogo
                    let datosPreguntaCat = this.datos.pregCat;
                    let indiceVersionPregCat = datosPreguntaCat.textVersions.findIndex(item => item.versionId == datosPregunta.versionId);
                    let indiceLangVersPregCat = datosPreguntaCat.textVersions[indiceVersionPregCat].questionLanguage.findIndex(item => item.lang == this.datos.idiomaNative);
                    datosPreguntaCat.textVersions[indiceVersionPregCat].questionLanguage[indiceLangVersPregCat].question = result.value;
                    console.log("datosPreguntaCatMod:",datosPreguntaCat);
                    this.actualizaPreguntaCatMaster(datosPreguntaCat);

                    Swal.close();
                    this.openSnackBar(confirMsg, "OK");
                  }
                  else{   //guardar nueva version
                    //guarda la nueva version en el catalogo
                    let datosPreguntaCat = this.datos.pregCat;
                    let idiomasNuevaVersion: any[] = [];
                    let indiceIdiomaNativo = this.datos.idiomas.findIndex(item => item.tipoIdioma == 1);
                    this.datos.catalogoIdiomasSurvey.forEach(idioma => {
                      let textoPreguntaNuevo = "";
                      if(idioma.abbr == this.datos.idiomas[indiceIdiomaNativo].nombreIdioma){
                        textoPreguntaNuevo = result.value;
                      }
                      idiomasNuevaVersion.push({
                        idLanguage: idioma.idLanguage,
                        lang: idioma.abbr,
                        question: textoPreguntaNuevo,
                        vivo: 1
                      });
                    });
                    let datosNuevaVersion = {
                      questionLanguage: idiomasNuevaVersion,
                      versionId: datosPreguntaCat.textVersions.length + 1,
                      vivo: 1
                    };
                    datosPreguntaCat.textVersions.push(datosNuevaVersion);
                    console.log("datosPreguntaCatMod:",datosPreguntaCat);
                    this.actualizaPreguntaCatMaster(datosPreguntaCat);

                    datosPregunta.questionLanguage = datosNuevaVersion.questionLanguage;
                    datosPregunta.versionId = datosNuevaVersion.versionId;
                    datosPregunta.typeAdd = 1;

                    confirMsg = "CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1";
                    this.translateSrv.get(confirMsg).subscribe((res: string) => { confirMsg = res; });


                    Swal.close();
                    this.openSnackBar(confirMsg, "OK");
                  }
                });
              }
            });

          }else{
            Swal.fire({
              title: this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SAVE_CAMB_PREGCAT"),
              showCancelButton: true,
              reverseButtons: true,
              confirmButtonText: this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_MOD_SAVE_CAMB_PREGCAT"),
              cancelButtonText: this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CAN_MOD_GUA_CAM_TEMP"),
              showLoaderOnConfirm: true,
              allowOutsideClick: () => !Swal.isLoading()
            }).then((resultadoPregunta_1) => {
              console.log(resultadoPregunta_1);

              if (resultadoPregunta_1.isConfirmed) {  // a esta encuesta
                datosPregunta.questionLanguage[indiceIdioma].question = result.value;
                datosPregunta.typeAdd = 4;
                Swal.close();
                this.openSnackBar(this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1"), "OK");
              }
            });
          }
        }
      }

    });
  }

  guardaNuevaVersionPregunta(datosPregunta:any){
    //guarda la nueva version en el catalogo
    let datosPreguntaCat = this.datos.pregCat;
    let idiomasNuevaVersion: any[] = [];
    let indiceIdiomaNativo = this.datos.idiomas.findIndex(item => item.tipoIdioma == 1);
    let indiceLangNatPreg = datosPregunta.questionLanguage.findIndex(item => item.lang == this.datos.idiomas[indiceIdiomaNativo].nombreIdioma);
    this.datos.catalogoIdiomasSurvey.forEach(idioma => {
      let textoPreguntaNuevo = "";
      if(idioma.abbr == this.datos.idiomas[indiceIdiomaNativo].nombreIdioma){
        textoPreguntaNuevo = datosPregunta.questionLanguage[indiceLangNatPreg].question;
      }
      idiomasNuevaVersion.push({
        idLanguage: idioma.idLanguage,
        lang: idioma.abbr,
        question: textoPreguntaNuevo,
        vivo: 1
      });
    });
    let datosNuevaVersion = {
      questionLanguage: idiomasNuevaVersion,
      versionId: datosPreguntaCat.textVersions.length + 1,
      vivo: 1
    };
    datosPreguntaCat.textVersions.push(datosNuevaVersion);
    console.log("datosPreguntaCatMod:",datosPreguntaCat);
    this.actualizaPreguntaCatMaster(datosPreguntaCat);

    datosPregunta.questionLanguage = datosNuevaVersion.questionLanguage;
    datosPregunta.versionId = datosNuevaVersion.versionId;
    datosPregunta.typeAdd = 1;

    Swal.close();
    this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1'), "OK");
  }

  actualizaPreguntaCatMaster(pregunta:any, mensaje?:string){

    this.preguntasService.setPreguntaCatMaster(pregunta).subscribe((respuesta:any) => {
      console.log("setPreguntaCatMaster:",respuesta);
      if(respuesta.success){
        if(pregunta.vivo == 0){
          this.dialogRef.close({
            borraPreguntaMC: true,
            idUnique: pregunta.idUnique
          });
        }
        else{
          this.datos.preguntaActualizadaMC = respuesta.question;
          this.datos.pregCat = respuesta.question;
        }
        if(mensaje != null){
          this.openSnackBar(mensaje, "OK");
        }
      }
    });
  }

  mapJsonPregCatJsonPregunta(preguntaCat: any, versionSel?:number){ //esta funcion transforma el json de una pregunta de catalogo a json de pregunta del template
    let answersPregTemp: any[] = [];
    preguntaCat.answers.forEach(answCat => {
      let ansPregTemp = {
        answerLanguage: answCat.textVersions[0].answerLanguage,
        idUnique: answCat.idUnique,
        logics: [],
        value: answCat.value,
        versionId: 1,
        vivo: answCat.vivo,
      };
      answersPregTemp.push(ansPregTemp);
    });
    let indiceVersion = 0;
    let versionElegida = 1;
    if(versionSel){
      indiceVersion = preguntaCat.textVersions.findIndex(item => item.versionId == versionSel);
      versionElegida = versionSel;
    }
    let preguntaTemplate = {
      answerType: preguntaCat.answerType,
      answers: answersPregTemp,
      color: 1,
      columns: this.datos.columns,
      delete: true,
      demographicId: preguntaCat.demographicId,
      edit: true,
      idUnique: preguntaCat.idUnique,
      order: 1,
      preload: false,
      questionLanguage: preguntaCat.textVersions[indiceVersion].questionLanguage,
      required: 1,
      typeAdd: 1, //enCM es ahora "typeAdd", 0 es pregunta en tempalte, 1 es pregunta de catalogo no en template y 2 es pregunta nueva no en template ni catalogo
      versionId: versionElegida,
      vivo: 1,
      typeCustom: preguntaCat.typeCustom,
      key: preguntaCat.key
    };
    return preguntaTemplate;
  }

  guardaNuevaPreguntaMC(datosPregunta: any){
    console.log("datosPregunta:",datosPregunta);
    let idiomasNuevaPreguntaItbm: any[] = [];
    let indiceIdiomaNativo = this.datos.idiomas.findIndex(item => item.tipoIdioma == 1);
    this.datos.catalogoIdiomasSurvey.forEach(idioma => {
      let textoPreguntaNuevo = "";
      if(idioma.abbr == this.datos.idiomas[indiceIdiomaNativo].nombreIdioma){
        textoPreguntaNuevo = datosPregunta.questionLanguage[datosPregunta.questionLanguage.findIndex(item => item.lang == this.datos.idiomaNative)].question;
      }
      idiomasNuevaPreguntaItbm.push({
        idLanguage: idioma.idLanguage,
        lang: idioma.abbr,
        question: textoPreguntaNuevo,
        vivo: 1
      });
    });

    // let idiomasNuevaPregunta: any[] = [];
    // this.datos.idiomas.forEach(idioma => {
    //   if(idioma.tipoIdioma == 0 || idioma.tipoIdioma == 1){
    //     let indiceIDlangSurv = this.datos.catalogoIdiomasSurvey.findIndex(item => item.abbr == idioma.nombreIdioma);
    //     let textoPreguntaNuevo = "";
    //     if(idioma.tipoIdioma == 1){
    //       textoPreguntaNuevo = datosPregunta.questionLanguage[datosPregunta.questionLanguage.findIndex(item => item.lang == this.datos.idiomaNative)].question;
    //     }
    //     idiomasNuevaPregunta.push({
    //       idLanguage: this.datos.catalogoIdiomasSurvey[indiceIDlangSurv].idLanguage,
    //       lang: idioma.nombreIdioma,
    //       question: textoPreguntaNuevo,
    //       vivo: 1
    //     });
    //   }
    // });
    let objAnswers: any[] = [];
    if(this.datos.pregunta.answerType != 2){
      this.datos.pregunta.answers.forEach((respuesta,i) => {
        let objAnswer: any = {
          idUnique: respuesta.idUnique,
          value: (i+1).toString(),
          textVersions:[
            {
              versionId: 1,
              answerLanguage: respuesta.answerLanguage
            }
          ]
        };
        objAnswers.push(objAnswer);
      });
    }
    let datosPreguntaCat: any = {
      answerType: this.datos.pregunta.answerType,
      textVersions: [
        {
          questionLanguage: idiomasNuevaPreguntaItbm,
          versionId: 1
        }
      ],
      typeSection: this.datos.answerType.tipoSeccion,
      broker: localStorage.getItem('instituto_id')
    };
    switch (this.datos.pregunta.answerType) {
      case 2: //abierta
        let indiceJsonCustom: number;
        if(this.datos.pregunta.typeAdd == 2){ //abierta tipo texto
          indiceJsonCustom = 1;
        }
        if(this.datos.pregunta.typeAdd == 3){ //abierta tipo numerico
          indiceJsonCustom = 2;
        }
        let jsonCustom = JSON.stringify(this.datos.jsonCustomAbiertas[this.datos.jsonCustomAbiertas.findIndex(item => item.tipo == indiceJsonCustom)].json); //cambiar el tipo de acuerdo al seleccionado en la modal
        datosPreguntaCat.jsonCustom = jsonCustom;
      break;
      case 1: case 3: case 4: case 6://una opcion nps, reactivo, demografico, multiopcion
        datosPreguntaCat.answers = objAnswers;
      break;
    }
    let preguntasGuardar = {
      questions: [datosPreguntaCat]
    };
    console.log("preguntasGuardar:",preguntasGuardar);
    this.preguntasService.savePreguntaCatMaster(preguntasGuardar).subscribe((respuesta:any) => {
      console.log("savePreguntaCatMaster:",respuesta);
      if(respuesta.success){
        respuesta.newQuestions.forEach((pregNueva:any) => {
          pregNueva.ocupada = false;
          this.datos.preguntaNuevaMC = pregNueva;
          this.datos.pregCat = pregNueva;
          this.datos.pregunta = this.mapJsonPregCatJsonPregunta(pregNueva);
        });
        Swal.close();
        this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_SUCC_GUAR_PREG_'), "OK");
      }
    });
  }

  actualizaPreguntaMC(datosPregunta: any){
    console.log("datosPregunta:",datosPregunta);
    Swal.fire({
      title: this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SAVE_CAMBIOS_PREGCAT'),
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_SI'),
      cancelButtonText: this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_NO'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((resultadoItbm) => {
      let confirMsg: string;
      if (resultadoItbm.value) {  //actualizar version

        //revisa el status de la pregunta
        if(datosPregunta.typeAdd == 4){   // si es una modificacion al texto de la pregunta
          this.guardaNuevaVersionPregunta(datosPregunta);
        }
        else if(datosPregunta.typeAdd == 5){  //si es una modificacion a las opciones de respuesta
          this.guardaNuevaVersionRespuesta(datosPregunta);  //busca versiones modificadas de respuestas y las guarda como nueva version
          this.guardaNuevaRespuesta(datosPregunta); //busca respuestas nuevas y las guarda a la pregunta de catalogo
          //si despues de recorrer el arreglo de answers sigue typeAdd 5, se le coloca el 1 manualmente
          if(datosPregunta.typeAdd == 5){
            datosPregunta.typeAdd = 1;
            this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1'), "OK");
          }
        }
      }
    });
  }

  borraPreguntaMC(datosPregunta: any){
    console.log("datosPregunta:",datosPregunta);
    let datosPreguntaCat = this.datos.pregCat;
    datosPreguntaCat.vivo = 0;
    console.log("datosPreguntaCatMod:",datosPreguntaCat);
    let titulo = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_MOD_DELE_PREG_MG';
    let btnSi = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_SI';
    let btnNo = 'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_NO';
    this.translateSrv.get(titulo).subscribe((res: string) => { titulo = res; });
    this.translateSrv.get(btnSi).subscribe((res: string) => { btnSi = res; });
    this.translateSrv.get(btnNo).subscribe((res: string) => { btnNo = res; });
    Swal.fire({
      icon: 'question',
      title: titulo,
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: btnSi,
      cancelButtonText: btnNo,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        this.actualizaPreguntaCatMaster(datosPreguntaCat,this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_RESP_DELCATOK'));
      }
    });
  }

  agregaTag(event: MatChipInputEvent, origen:number): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      if(value.substr(0,1) == '#'){
        switch (origen) {
          case 1: //pregunta nueva
            this.datosPreguntaNueva.tags.push(value.trim());
          break;
          case 2: //detalle de pregunta
            this.datos.pregCat.tags.push(value.trim());
            this.actualizaPreguntaCatMaster(this.datos.pregCat, this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_RESP_ADDTAGOK'));
          break;
        }
      }
      else{
        this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_RESP_ADDTAGERR'), "OK");
      }
    }
    if (input) {
      input.value = '';
    }
  }

  borraTag(tag: any, origen:number): void {
    let indice: number;
    switch (origen) {
      case 1: //pregunta nueva
        indice = this.datosPreguntaNueva.tags.indexOf(tag);
        if (indice != -1) {
          this.datosPreguntaNueva.tags.splice(indice, 1);
        }
      break;
      case 2: //detalle de pregunta
        indice = this.datos.pregCat.tags.indexOf(tag);
        if (indice != -1) {
          this.datos.pregCat.tags.splice(indice, 1);
          this.actualizaPreguntaCatMaster(this.datos.pregCat, this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_RESP_DELTAGOK'));
        }
      break;
    }

  }

  dropPregunta(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  ///// FUNCIONES AUDIO NUEVO

  recuperaConfigVoces(){
    this.surveyProductService.enviaDatosASurvProd({ recuperaConfigVoces: true });
    this.surveyProductService.recibidosSurvProd.pipe(first()).subscribe((datos:any) => {
      this.infoVoces = datos.infoVoces;
    });
  }

  DEMO_agregarAudioPregunta(datosPregunta:any, tipo:string){
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose: true,
      width: '60%',
      data: {
        opcion: 'nuevoAudio',
        tipo,
        idiomas: this.datos.idiomas,
        datosPregunta,
        pregCat: this.datos.pregCat,
        datosPregSP: this.datos.pregunta
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        if(result.base64 != undefined){
          datosPregunta.audio = true;
          datosPregunta.audioData = '';
          datosPregunta.audioUrl = ''
          setTimeout(() => {
            datosPregunta.audioData = result.base64;
            datosPregunta.audioUrl = result.url
          });
        }
      }
    });
  }

  DEMO_reproducirAudioPregunta(datosPregunta:any){
    datosPregunta.audioUrl = this.DEMO_convierteAudioBlob(datosPregunta.audioData);
  }

  DEMO_convierteAudioBlob(base64:string){
    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    const contentType = 'audio/mpeg';
    const b64Data = base64;

    const blob = b64toBlob(b64Data, contentType);
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  }

  DEMO_borrarAudioPregunta(datosPregunta:any){
    Swal.fire({
      icon: 'question',
      title: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.BORRAR'),
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.CANCELAR'),
      confirmButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.ACEPTAR'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        const codigo = Math.random().toString(36).substring(7);
        Swal.fire({
          title: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.CONFIRMAR_BORRAR') + '<font color="red">' + codigo + '</font>',
          icon: 'info',
          input:'text',
          showCancelButton: true,
          reverseButtons: true,
          cancelButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.CANCELAR'),
          confirmButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.ACEPTAR')
        }).then( (borrar) => {
          if (borrar.value == codigo) {
            datosPregunta.audio = false;
            datosPregunta.audioData = '';
            datosPregunta.audioUrl = '';
            this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.BORRADO_OK'), "OK");
          } else{
            if(!borrar.dismiss){
              Swal.fire({
                icon: 'error',
                title: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.CODIGO_MAL'),
                showConfirmButton: true,
                confirmButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.ACEPTAR')
              })
            }
          }
        });
      }
    });
  }

  getQuestionAudio(idUnique:number, versionId:number, datosPregunta:any){
    const conAudio = (idioma) => {
      const datosIdioma = datosPregunta.questionLanguage.find(item => item.lang == idioma.nombreIdioma);
      if(datosIdioma != undefined){
        return datosIdioma.audio != undefined ? true : false;
      } else return true;
    }
    datosPregunta.questionLanguage.forEach(idioma => {
      if(this.infoVoces[idioma.lang] != undefined){ //entra si el idioma de la traduccion es uno de los que se eligieron en la configuracion de idioma
        const datosURL = {
          idUnique,
          versionId,
          lang: idioma.lang,
          gender: this.infoVoces[idioma.lang].gender,
          languageCode: this.infoVoces[idioma.lang].languageCode,
          nameVoice: this.infoVoces[idioma.lang].nameVoice
        }
        this.preguntasService.getQuestionAudio(datosURL).subscribe((respuesta:any) => {
          // console.log("getQuestionAudio ",idioma.lang,":",respuesta);
          if(respuesta.success == true){
            idioma.audio = true;
            idioma.audioUrl = respuesta.questionAudio.url;
          }
          idioma.audio = respuesta.success;
          // idioma.audioUrl = respuesta.
          if(this.datos.idiomas.every(conAudio)){
            console.log("se consultaron los audios de todos los idiomas de la version");

          }
        });
      }
    });
  }

  salir(){
    if (this.datos.pregunta.typeCustom==2) {
      console.log('this.datos.pregunta.key',this.datos.pregunta.key);

      if (this.datos.pregunta.key==undefined|| this.datos.pregunta.key=='') {
        Swal.fire({
          icon: 'error',
          title: this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SIN_CLA_ESPE'),
          confirmButtonText: this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_OK'),
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading()
        });
      }else{
        this.dialogRef.close(this.datos);

      }
    }else{
      this.dialogRef.close(this.datos);
    }
  }
  salirPregNueva(opcion:number){
    console.log("datosPreguntaNueva:",this.datosPreguntaNueva);

    switch (opcion) {
      case 1: //salir sin guardar
        this.dialogRef.close(false);
      break;
      case 2: //guardar practica
        let titulo: string;
        let btnOk = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_OK');
        console.log('****this.datosPreguntaNueva.tipo***',this.datosPreguntaNueva.tipo);

        if(this.datosPreguntaNueva.tipo != 0){  //si tiene tipo de pregunta seleccionado
          if(this.datosPreguntaNueva.pregunta != ""){ //si el texto es diferente a ""
            if(this.datosPreguntaNueva.tags.length == 0 && !this.datos.modoEmpresa){ //si no tiene tags y es modo itbm
              titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SIN_TAGS');
            }
            else{ //si tiene tags
              if(this.datosPreguntaNueva.tipo == 1 || this.datosPreguntaNueva.tipo == 4 || this.datosPreguntaNueva.tipo == 6){ //si es de tipo opciones
                if(this.datosPreguntaNueva.respuestas.length == 0){
                  titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_NO_CONT_SIN_HAB_AGRE_OPC_RESP');
                }
                else{
                  if(this.datosPreguntaNueva.respuestas.length < 2){
                    titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SIN_OPC_RESP');
                  }
                  else{
                    if((this.datosPreguntaNueva.tipo == 4 || this.datosPreguntaNueva.tipo == 6) && this.datos.tipoSeccion == 4){  //si es específicamente un demografico
                      console.log("this.datosPreguntaNueva.demografico",this.datosPreguntaNueva.demografico);
                      console.log("this.datos.modoEmpresa",this.datos.modoEmpresa);

                      if(!this.datos.modoEmpresa && this.datosPreguntaNueva.demografico == 0){
                        titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SIN_TIPO_DEMO');
                      }
                      else{
                        if(this.datosPreguntaNueva.descripcion == ''){
                          titulo = 'Aún no ha ingresado la descripción corta de la pregunta';
                        } else{
                          if (this.datosPreguntaNueva.typeCustom==2) {
                            if (this.datosPreguntaNueva.key=='') {
                              titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SIN_CLA_ESPE');

                            }else{
                              this.datosPreguntaNueva.respuestas.forEach(respuesta => {
                                this.datosPreguntaNueva.respuestasTextos.push(respuesta.versiones[0].respuesta);
                              });
                              this.dialogRef.close(this.datosPreguntaNueva);
                            }
                          }else{
                            this.datosPreguntaNueva.respuestas.forEach(respuesta => {
                              this.datosPreguntaNueva.respuestasTextos.push(respuesta.versiones[0].respuesta);
                            });
                            this.dialogRef.close(this.datosPreguntaNueva);
                          }
                        }
                      }
                    }
                    else{
                      if (this.datosPreguntaNueva.typeCustom==2) {
                        if (this.datosPreguntaNueva.key=='') {
                        titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SIN_CLA_ESPE');

                        }else{
                          this.datosPreguntaNueva.respuestas.forEach(respuesta => {
                            this.datosPreguntaNueva.respuestasTextos.push(respuesta.versiones[0].respuesta);
                          });
                          this.dialogRef.close(this.datosPreguntaNueva);
                        }
                      }else{
                        this.datosPreguntaNueva.respuestas.forEach(respuesta => {
                          this.datosPreguntaNueva.respuestasTextos.push(respuesta.versiones[0].respuesta);
                        });
                        this.dialogRef.close(this.datosPreguntaNueva);

                      }
                    }
                  }
                }
              }
              else if(this.datosPreguntaNueva.tipo == 2){   //si es tipo abierta
                if(this.datosPreguntaNueva.tipoAbierta == 0){   //si no ha selecionado el tipo de abierta
                  titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SIN_TIPO_RESP');
                }
                else{
                  if(this.datos.tipoSeccion == 4){  //si es un demografico abierto
                    if(!this.datos.modoEmpresa&&this.datosPreguntaNueva.demografico == 0){
                      titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SIN_TIPO_DEMO');
                    }
                    else{
                      if(this.datosPreguntaNueva.descripcion == ''){
                        titulo = 'Aún no ha ingresado la descripción corta de la pregunta';
                      } else{
                        if (this.datosPreguntaNueva.typeCustom==2) {
                          if (this.datosPreguntaNueva.key=='') {
                            titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SIN_CLA_ESPE');

                          }else{
                            this.dialogRef.close(this.datosPreguntaNueva);
                          }
                        }else{
                          this.dialogRef.close(this.datosPreguntaNueva);
                        }                        
                      }
                    }
                  }
                  else{
                    if (this.datosPreguntaNueva.typeCustom==2) {
                      if (this.datosPreguntaNueva.key=='') {
                      titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SIN_CLA_ESPE');

                      }else{
                        this.dialogRef.close(this.datosPreguntaNueva);
                      }
                    }else{
                      this.dialogRef.close(this.datosPreguntaNueva);
                    }
                  }
                }
              }
              else{
                if (this.datosPreguntaNueva.typeCustom==2) {
                  if (this.datosPreguntaNueva.key=='') {
                                titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_SIN_CLA_ESPE');

                  }else{
                    this.dialogRef.close(this.datosPreguntaNueva);
                  }
                }else{
                  this.dialogRef.close(this.datosPreguntaNueva);
                }
              }
            }
          }
          else{
            titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_NO_CONT_SIN_HAB_ESCR_OPC_RESP');
          }
        }
        else{
          titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_NO_CONT_SIN_HAB_ELE_TIP_RESP');
        }
        if(titulo){
          Swal.fire({
            icon: 'error',
            title: titulo,
            confirmButtonText: btnOk,
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading()
          });
        }
      break;
    }
  }
  salirFANueva(opcion:number){
    switch (opcion) {
      case 1: //salir sin guardar
        this.dialogRef.close(false);
      break;
      case 2: //guardar pregunta
        this.dialogRef.close(this.datosPracticaNueva);

      break;
    }
  }

}
